import React from 'react';
import { ExtensionsConfigOptions } from '../../Editor/types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { Editor } from '@tiptap/react';

import s from './buttons.scss';

export interface Props {
  editor: Editor;
  hideWhen?: keyof ExtensionsConfigOptions;
}

const Separator: React.FC<Props> = ({ hideWhen, editor }) => {
  if (hideWhen && !isExtensionInstalled(editor, hideWhen)) {
    return null;
  }
  return (
    <div className={s['separator']}>
      <div></div>
    </div>
  );
};
Separator.displayName = 'Separator';

export default Separator;
